import React from "react"
import { CreateOrganizationForm } from "@/components/forms"
import type { CreateOrganizationStepProps } from "./CreateOrganizationStep.types"

export const CreateOrganizationStep: React.FunctionComponent<
  CreateOrganizationStepProps
> = ({ onSuccess }) => {
  return <CreateOrganizationForm onSuccess={onSuccess} />
}
